import { Property } from '@propertypal/shared/src/types/property';
import getSellingAgent, { getSellingAgentColor } from '@propertypal/shared/src/utils/property/getSellingAgent';
import React, { FunctionComponent } from 'react';
import { Container, Logo } from './PropertyAgentBar.style';

interface Props {
  property: Property;
  hideOnMobile?: boolean;
}

const PropertyAgentBar: FunctionComponent<Props> = (props) => {
  const sellingAgent = getSellingAgent(props.property);
  const [agentColor] = getSellingAgentColor(props.property);

  if (!sellingAgent || !agentColor) {
    return null;
  }

  return (
    <Container color={agentColor} hideOnMobile={props.hideOnMobile} className="hide-print">
      <Logo src={sellingAgent?.logo?.premier} />
    </Container>
  );
};

export default PropertyAgentBar;
